
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'H_nHLymphoma',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/H_nHLymphoma.vue